import $ from 'jquery';
import 'jquery-validation';
import './experian-intuitive-validation';
import '../../node_modules/jquery-validation/dist/additional-methods';

// http://clearwater.com.au/code/acn
const validateACN = input => {
    const weights = [8, 7, 6, 5, 4, 3, 2, 1];
    const acn = input.replace(/\s/g, '');

    if (acn.length === 9) {
        let sum = 0;
        for (let i = 0; i < weights.length; i += 1) {
            sum += weights[i] * acn[i];
        }
        const check = (10 - (sum % 10)) % 10;

        return parseInt(acn[8], 10) === check;
    }

    return false;
};

// http://clearwater.com.au/code/abn
const validateABN = input => {
    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

    // strip anything other than digits
    const abn = input.replace(/\s/g, '');

    if (abn.length === 11) {
        let sum = 0;
        for (let i = 0; i < weights.length; i += 1) {
            const digit = abn[i] - (i === 0 ? 1 : 0);
            sum += weights[i] * digit;
        }

        return (sum % 89) === 0;
    }

    return false;
};

$.validator.addMethod('acn', function (input, element) {
    return this.optional(element) || validateACN(input);
}, 'Invalid ACN');

$.validator.addMethod('abn', function (input, element) {
    return this.optional(element) || validateABN(input);
}, 'Invalid ABN');

$.validator.addMethod('abnacn', function (input, element) {
    return this.optional(element) || validateABN(input) || validateACN(input);
}, 'Invalid ABN or ACN');

$.validator.addMethod('tfn', function (input, element) {
    if (this.optional(element) || $(element).is('input[type="radio"]')) return true;
    // strip anything other than digits
    const tfn = input.replace(/[^\d]/g, '');

    // validate only digits
    const isNumber = /^[0-9]+$/.test(tfn);
    if (!isNumber) {
        return false;
    }

    // validate length
    if (tfn.length !== 9) {
        return false;
    }

    const digits = tfn.split('');

    // do the calcs
    const sum = (digits[0] * 1)
        + (digits[1] * 4)
        + (digits[2] * 3)
        + (digits[3] * 7)
        + (digits[4] * 5)
        + (digits[5] * 8)
        + (digits[6] * 6)
        + (digits[7] * 9)
        + (digits[8] * 10);

    const remainder = sum % 11;

    return remainder === 0;
}, 'Invalid TFN');

$.validator.addMethod(
    'format', (input, element) => element.value === '' || input.length === 4,
    'Please enter a valid four-digit promo code'
);

const validateMinLength = (value, el) => {
    const min = $(el).attr('minlength') - 1;
    return value.length > min;
};

$.validator.addMethod(
    'minlength', (input, element) => validateMinLength(input, element),
    $.validator.format('Please enter required character number')
);

const validateScriptInjection = value => {
    const inputCheck = /^$|^\w+$/;

    // Check input value
    return inputCheck.test(value);
};

$.validator.addMethod(
    'preventscript', input => validateScriptInjection(input),
    $.validator.format('Please enter valid characters')
);

const validateEmployee = (value, el) => {
    let employeeRule = false;
    const employeeValue = parseInt(value, 10);

    if (employeeValue > 0) {
        if ($(el).attr('id') === $('[data-toggle="secondary"]').attr('id')) {
            if (employeeValue > parseInt($('[data-toggle="primary"]').val(), 10)) {
                employeeRule = false;
            } else {
                employeeRule = true;
            }
        } else {
            employeeRule = true;
        }
    }

    return employeeRule;
};

$.validator.addMethod(
    'employeerule', (input, element) => validateEmployee(input, element),
    (error, element) => {
        if (parseInt(element.value, 10) === 0) {
            return 'Please enter a value more than or equal to 1.';
        }

        return 'Please enter a value less than or equal to the number above.';
    }
);

$.validator.addMethod('url', function (input, element) {
    // eslint-disable-next-line no-useless-escape
    return this.optional(element) || /^(http(s)?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(input);
}, 'Please enter a valid website address');

// apply auto input-mask on your-tfn text field
const yourTFN = document.querySelector('input[data-rule-tfn="True"]');

if (yourTFN) {
    let timeoutYourTFN = null;
    const delayTimeoutYourTFN = 100;
    yourTFN.addEventListener('keyup', () => {
        clearTimeout(timeoutYourTFN);
        timeoutYourTFN = setTimeout(() => {
            if (yourTFN.value.length === 9) {
                yourTFN.value = yourTFN.value.replace(/ /g, '');
                const number = yourTFN.value;
                yourTFN.value = number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                yourTFN.blur();
                yourTFN.focus();
            }
        }, delayTimeoutYourTFN);
    }, false);
}

const formValidation = () => {
    const forms = $('form');

    if (!forms.hasClass('form-layout')) return;

    forms.each(function () {
        const form = $(this);

        form.validate({
            // debug: true,
            ignore: ':hidden:not(.js-validate-hidden)',
            errorPlacement: (error, element) => {
                error.appendTo(element.parents('.input-wrapper'));
                error.addClass('error-msg');
            },
            highlight: (element, errorClass, validClass) => {
                const $el = $(element);
                $el.parents('.form-element').addClass('has-error');
                $el.addClass(errorClass).removeClass(validClass);
                $el.attr('disabled', false);

                // special for hidden input validation, it use inline custom error
                if ($el.hasClass('js-validate-hidden')) {
                    $el.parents('.js-parent-element').addClass('has-error');
                }
            },
            unhighlight: (element, errorClass, validClass) => {
                const $el = $(element);
                $el.parents('.form-element').removeClass('has-error');
                $el.removeClass(errorClass).addClass(validClass);

                // special for hidden input validation, it use inline custom error
                if ($el.hasClass('js-validate-hidden')) {
                    $el.parents('.js-parent-element').removeClass('has-error');
                }
            }
        });
    });
};

const addressSuggestion = () => {
    const $address = $('.address-search');
    if ($address.length === 0) return;

    $address.each(function () {
        const $el = $(this);
        const options = {
            token: 'eee6e586-7bd9-4f6b-8fbb-d1bbdd89ba88',
            useSpinner: true,
            searchAgain: { location: this },
            submmitAddress: 'Use address entered',
            useAddressEnteredText: 'Use address entered',
            elements: {
                addressLine1: this,
                addressLine2: this,
                addressLine3: this,
                locality: $(`#${$el.data('suburb-id')}`)[0] || $('<div class="not-exist hidden"></div>'),
                province: $(`#${$el.data('state-id')}`)[0] || $('<div class="not-exist hidden"></div>'),
                postalCode: $(`#${$el.data('postcode-id')}`)[0] || $('<div class="not-exist hidden"></div>'),
                input: this,
                countryList: $('<input value="AUS" />')[0]
            }
        };

        /* eslint-disable-next-line */
        var address = new ContactDataServices.address(options);
    }).parent().addClass('validation-experian-qas');
};


// Might happen
const manuallyInputAddress = () => {
    const $addressInput = $('.address-search');

    $addressInput.on('change', e => {
        const $this = $(e.target);
        const dataAttr = $this.data();

        const { suburbId, stateId, postcodeId } = dataAttr;

        $(`#${suburbId}`).on('change', sub => {
            if ($(sub.target).val() !== '') {
                $(`#${suburbId}`).attr('readonly', true);
            }
        });

        $(`#${stateId}`).on('change', st => {
            if ($(st.target).val() !== null) {
                $(`#${stateId}`).attr('readonly', true);
            }
        });

        $(`#${postcodeId}`).on('change', post => {
            if ($(post.target).val() !== '') {
                $(`#${postcodeId}`).attr('readonly', true);
            }
        });
    });
};

const numbers = () => {
    if ($('#DaytimeTelephone, #Mobile').length === 0) return;

    $('#DaytimeTelephone, #Mobile').on('input', e => {
        const $this = $(e.currentTarget);

        if ($this.val() !== '') {
            $this.val($this.val().replace(/[^0-9.]/g, ''));
            if ((e.which !== 46 || $this.val().indexOf('.') !== -1) && (e.which < 48 || e.which > 57)) {
                e.preventDefault();
            }
        }
    });
};

$(() => {
    formValidation();
    addressSuggestion();
    manuallyInputAddress();
    numbers();
});

const addressStates = (input, reset) => {
    const $this = $(input);
    const dataAttr = $this.data();

    const { suburbId, stateId, postcodeId, toggle } = dataAttr;

    if (toggle !== undefined) {
        const address = `${toggle}-address`;
        if (!reset) {
            if ($(`.${address}-search`).val() !== '') {
                $(`.${address}-search`).attr('readonly', true);
                $(`.${address}-suburb`).attr('readonly', true)
                    .removeClass('error')
                    .siblings('.error')
                    .hide()
                    .parents('.form-field')
                    .removeClass('has-error');
                $(`.${address}-state`).attr('readonly', true)
                    .removeClass('error')
                    .siblings('.error')
                    .hide()
                    .parents('.form-field')
                    .removeClass('has-error');
                $(`.${address}-postcode`).attr('readonly', true)
                    .removeClass('error')
                    .siblings('.error')
                    .hide()
                    .parents('.form-field')
                    .removeClass('has-error');
            }
        } else {
            $(`.${address}-search, .${address}-suburb, .${address}-state, .${address}-postcode`)
                .attr('readonly', false);
        }
    }

    if (!reset) {
        if ($(`#${suburbId}`).val() !== '') {
            $(`#${suburbId}`).attr('readonly', true);
        }

        if ($(`#${stateId}`).val() !== null) {
            $(`#${stateId}`).attr('readonly', true);
        }

        if ($(`#${postcodeId}`).val() !== '') {
            $(`#${postcodeId}`).attr('readonly', true);
        }
    } else {
        $(`#${suburbId}, #${stateId}, #${postcodeId}`).attr('readonly', false);
    }
};

export default addressStates;
